module.exports = __webpack_public_path__ + "img/20240904_1.7ac6b7f7.png";